import axios from 'axios';
import { getAccessToken, getCurrentCompany } from './auth';
import {logout} from './auth';

const api = axios.create({
  baseURL: API_ENDPOINT,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  },
  responseType: 'json',
  transformResponse: [(data) => {
    return data;
  }]
});

function getCompanyIdHeader() {
  const currentCompany = getCurrentCompany();
  if (currentCompany) {
    return currentCompany.id.toString();
  }
  return 'thymo-inc';
  // return null;
}

function getAuthorizationHeader() {
  const accessToken = getAccessToken();
  if (accessToken) {
    return `${accessToken}`;
  }
  return null;
}

export function getHeaders() {
  return {
    Authorization: getAuthorizationHeader(),
    'Company-Id': getCompanyIdHeader(),
  };
}

api.interceptors.request.use(config => {
  const newConfig = config;
  newConfig.headers = { ...newConfig.headers, ...getHeaders() };
  return newConfig;
});

const errorInterceptor = err => {
  return new Promise((resolve, reject) => {
    if (
      err.response &&
      err.response.status === 401// &&
      // err.config &&
      // !err.config.isRetryRequest &&
      // !err.config.isAuthenticationRequest
    ) {
      logout();
      reject(new Error('Unauthenticated'));
    }
    if(err.response && err.response.data && err.response.data.error) {
      reject(err.response.data.error);
    }else {
      reject(err);
    }

  });
};

const responseInterceptor = (response)  => {
  return response.data;
};

api.interceptors.response.use(responseInterceptor, errorInterceptor);

api.CancelToken = axios.CancelToken;
api.isCancel = axios.isCancel;

export default api;
